module.exports = __webpack_public_path__ + "static/img/The_classroom.0a6463c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/The_classroom.png
// module id = jkcr
// module chunks = 0